import * as React from 'react';
import styled from 'react-emotion';
import store from '../store';
import { IState } from '../store/reducers';
import Button from './Button';
import Column from './Column';
import Container from './Container';
import Row from './Row';
import Text from './Text';
import Title from './Title';

const ErrorContainer = styled(Container)`
  background-color: #444;
`;

const ErrorBody = styled(Column)`
  padding: 5vh 5vw;
`;

export const ErrorMessage: React.SFC<{ onReset: () => void }> = ({
  onReset,
}) => {
  const {
    theme: { colors },
  }: IState = store.getState();

  return (
    <ErrorContainer>
      <Row align="flex-end" justify="center">
        <Title color={colors.error}>
          {'Sorry, there was an unexpected error'}
        </Title>
      </Row>
      <ErrorBody align="center" justify="space-around">
        <Text color="white" size="2rem">
          Josh has been sent a notification about the problem. If he doesn't get
          back with you soon, please email him at josh@texnrewards.com.
        </Text>
        <Text color="white" size="2rem">
          Tap the button below to reset and reload the app.
        </Text>
      </ErrorBody>
      <Row align="flex-start" justify="center">
        <Button bg={colors.error} onClick={onReset}>
          Reset
        </Button>
      </Row>
    </ErrorContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.tsx